import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d37273ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "blueStepFinal col-12 mb-3"
};
const _hoisted_2 = { class: "col-12 bg-white border rounded-bottom pt-3 mb-4" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row border-bottom" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
        /*#__PURE__*/ _createElementVNode("h2", { class: "h5 mb-3 mt-1 text-left" }, "Zusammenfassung")
    ])
], -1));
const _hoisted_4 = { class: "row mb-1 border-bottom" };
const _hoisted_5 = { class: "col-12 font7 my-3" };
const _hoisted_6 = { class: "row mb-2" };
const _hoisted_7 = { class: "col-8 pr-1" };
const _hoisted_8 = { class: "col-4 text-right pl-0" };
const _hoisted_9 = { class: "row mb-2" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-8 pr-1" }, "MwSt.", -1));
const _hoisted_11 = { class: "col-4 text-right pl-0" };
const _hoisted_12 = { class: "row mb-2" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-8 pr-1" }, "Zwischensumme (inkl. MwSt)", -1));
const _hoisted_14 = { class: "col-4 text-right pl-0" };
const _hoisted_15 = { class: "row mb-2" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-8 pr-1" }, "Versand (inkl. MwSt)", -1));
const _hoisted_17 = { class: "col-4 text-right pl-0" };
const _hoisted_18 = {
    key: 1,
    class: "badge badge-light-green p-y-1 p-x-2 font-weight-normal font8-responsive"
};
const _hoisted_19 = {
    key: 0,
    class: "row mb-2"
};
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-fragezeichen fc-gray1" }, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-4 text-right pl-0" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "badge badge-light-green p-y-1 p-x-2 font-weight-normal font8-responsive" }, " Inklusive ")
], -1));
const _hoisted_22 = {
    key: 1,
    class: "row"
};
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-8 pr-1" }, "Gutscheinwert", -1));
const _hoisted_24 = { class: "col-4 text-right pl-0" };
const _hoisted_25 = { class: "row mt-3" };
const _hoisted_26 = { class: "col-12 mb-2 font2 strong text-right" };
const _hoisted_27 = {
    key: 0,
    class: "row mb-1"
};
const _hoisted_28 = { class: "col-12 font7 text-right" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        d: "M14.2735 7.71998L8.2735 1.71998C8.0335 1.47998 7.70016 1.33331 7.3335 1.33331H2.66683C1.9335 1.33331 1.3335 1.93331 1.3335 2.66665V7.33331C1.3335 7.69998 1.48016 8.03331 1.72683 8.27998L7.72683 14.28C7.96683 14.52 8.30016 14.6666 8.66683 14.6666C9.0335 14.6666 9.36683 14.52 9.60683 14.2733L14.2735 9.60665C14.5202 9.36665 14.6668 9.03331 14.6668 8.66665C14.6668 8.29998 14.5135 7.95998 14.2735 7.71998ZM3.66683 4.66665C3.1135 4.66665 2.66683 4.21998 2.66683 3.66665C2.66683 3.11331 3.1135 2.66665 3.66683 2.66665C4.22016 2.66665 4.66683 3.11331 4.66683 3.66665C4.66683 4.21998 4.22016 4.66665 3.66683 4.66665ZM11.5135 10.18L8.90016 12.7933C8.76683 12.9266 8.56016 12.9266 8.42683 12.7933L5.8135 10.18C5.4335 9.79331 5.2335 9.22665 5.36683 8.61998C5.4935 8.03331 5.96016 7.54665 6.54016 7.39331C7.16683 7.22665 7.7735 7.41998 8.16683 7.82665L8.66683 8.30665L9.1535 7.81998C9.4535 7.51998 9.8735 7.33331 10.3335 7.33331C11.2535 7.33331 12.0002 8.07998 12.0002 8.99998C12.0002 9.45998 11.8135 9.87998 11.5135 10.18Z",
        fill: "#000000"
    })
], -1));
const _hoisted_30 = {
    "data-toggle": "tooltip",
    "data-placement": "bottom",
    class: "strong font7",
    "data-original-title": "myPOINTS werden Dir nach Ablauf der Rückgabefrist gutgeschrieben\n                            (sofern Du die Bestellung nicht stornierst oder retournierst) und können gegen Gutscheine\n                            eingetauscht werden."
};
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-ankaufbedingungen" }, null, -1));
const _hoisted_32 = { class: "row mt-3" };
const _hoisted_33 = { class: "col-12" };
const _hoisted_34 = {
    key: 0,
    class: "icon-spin4 animate-spin"
};
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "row mt-3" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "col-12 text-center" }, [
        /*#__PURE__*/ _createElementVNode("p", { class: "font7 greyish_text" }, [
            /*#__PURE__*/ _createTextVNode(" Mit dem Klick bestätige ich, dass ich die "),
            /*#__PURE__*/ _createElementVNode("a", {
                href: "/agb",
                target: "_blank",
                title: "AGB",
                class: "strong link-gray"
            }, "AGB"),
            /*#__PURE__*/ _createTextVNode(" gelesen und akzeptiert habe. ")
        ])
    ])
], -1));
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "hidden",
    id: "klarna-payments-container"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_coupon_usage_block = _resolveComponent("coupon-usage-block");
    const _component_formatted_price = _resolveComponent("formatted-price");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.totals)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_coupon_usage_block, {
                    "coupon-type": _ctx.CouponType.BLUE,
                    coupons: (_a = _ctx.coupons) !== null && _a !== void 0 ? _a : [],
                    "current-coupon-code": _ctx.currentCouponCode,
                    onLoadCoupons: _ctx.loadCoupons,
                    "remove-coupon-callback": _ctx.removeCoupon,
                    "confirm-coupon-code-callback": _ctx.confirmCouponCode,
                    class: "col-12 pt-1 pb-2 bg-white border-top border-left border-right rounded-top mb-0"
                }, null, 8, ["coupon-type", "coupons", "current-coupon-code", "onLoadCoupons", "remove-coupon-callback", "confirm-coupon-code-callback"]),
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, _toDisplayString(`${_ctx.totals.products} Artikel (exkl. MwSt)`), 1),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_formatted_price, {
                                        price: _ctx.totals.netto_products
                                    }, null, 8, ["price"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_component_formatted_price, {
                                        price: _ctx.totals.product_tax
                                    }, null, 8, ["price"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                                _hoisted_13,
                                _createElementVNode("div", _hoisted_14, [
                                    _createVNode(_component_formatted_price, {
                                        price: _ctx.totals.brutto_products
                                    }, null, 8, ["price"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("div", _hoisted_17, [
                                    (_ctx.totals.shipping_total > 0)
                                        ? (_openBlock(), _createBlock(_component_formatted_price, {
                                            key: 0,
                                            price: _ctx.totals.shipping_total
                                        }, null, 8, ["price"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_18, " Kostenlos "))
                                ])
                            ]),
                            (_ctx.hasWarrantyForAll)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", {
                                        class: "col-8 pr-1 pointerhover",
                                        onClick: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_ctx.showPopUp && _ctx.showPopUp(...args)))
                                    }, [
                                        _createTextVNode(" 36 Monate Garantie "),
                                        _hoisted_20
                                    ]),
                                    _hoisted_21
                                ]))
                                : _createCommentVNode("", true),
                            (_ctx.totals.voucher_total)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _hoisted_23,
                                    _createElementVNode("div", _hoisted_24, [
                                        _createTextVNode(" - "),
                                        _createVNode(_component_formatted_price, {
                                            price: _ctx.totals.voucher_total
                                        }, null, 8, ["price"])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_formatted_price, {
                                price: _ctx.totals.brutto_total
                            }, null, 8, ["price"])
                        ])
                    ]),
                    (_ctx.isLogin)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createTextVNode(" Mit dieser Bestellung "),
                                _createElementVNode("span", _hoisted_30, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.totals.my_points), 1),
                                    _createTextVNode(" myPOINTS "),
                                    _hoisted_31
                                ]),
                                _createTextVNode(" sichern. ")
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                                type: "button",
                                id: "confirm_checkout",
                                class: _normalizeClass(["buttonBase buttonGreen w-100 mb-3 font6-responsive [ JS_Sticky_Anchor_Confirm_Checkout ]", _ctx.valid_for_checkout === false && !_ctx.initial ? 'nope nope-shake' : '']),
                                onClick: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => (_ctx.confirm_purchase && _ctx.confirm_purchase(...args)))
                            }, [
                                (_ctx.valid_for_checkout === null)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                                    : _createCommentVNode("", true),
                                _createTextVNode(" Bestätigen und kaufen ")
                            ], 2)
                        ])
                    ]),
                    _hoisted_35
                ])
            ]))
            : _createCommentVNode("", true),
        _hoisted_36
    ], 64));
}
